export const PHONE_DISPLAY = "(514) 651-3779";
export const PHONE_TEL = "tel:+15146513779";
export const EMAIL = "herve.g@solucofinancialgroup.ca";
export const FACEBOOK_URL = "https://www.facebook.com/solubailFinancement/";

export const MARQUEE_ITEMS = [
  "CRÉDIT-BAIL",
  "REFINANCEMENT",
  "FONDS DE ROULEMENT",
  "APPROBATION 24–48H",
  "100% QUÉBEC",
  "MATÉRIEL LOURD & CAMIONS",
  "APPAREILS ESTHÉTIQUES",
  "(514) 651-3779",
];

export const SERVICES = [
  {
    number: "01",
    title: "Crédit-Bail Équipement",
    tag: "Solution populaire",
    description:
      "Acquérez du matériel neuf ou d'occasion sans toucher à la liquidité de votre entreprise. Vos loyers sont déductibles d'impôt à 100 %.",
    highlights: [
      "Conservez votre marge de crédit bancaire intacte",
      "Paiements saisonniers adaptés à votre réalité",
      "Option d'achat symbolique en fin de terme (10 $)",
    ],
  },
  {
    number: "02",
    title: "Refinancement d'Équipements",
    tag: "Déblocage de capital",
    description:
      "Transformez la valeur nette de votre machinerie existante en fonds de roulement immédiat pour propulser vos opérations.",
    highlights: [
      "Jusqu'à 75 % de la valeur marchande débloquée",
      "Vous conservez l'usage quotidien de vos équipements",
      "Remboursement flexible sur 24 à 60 mois",
    ],
  },
  {
    number: "03",
    title: "Fonds de Roulement",
    tag: "Croissance rapide",
    description:
      "Un financement à court terme pour saisir de nouveaux contrats, acheter de la matière première ou faire face aux imprévus.",
    highlights: [
      "Décision et déboursé ultra-rapides",
      "Aucune garantie immobilière exigée",
      "Paiements ajustés à votre cycle de trésorerie",
    ],
  },
];

export const EQUIPMENT = [
  {
    slug: "construction",
    name: "Construction & Excavation",
    examples: "Pelles mécaniques, bulldozers, chargeurs sur roues, grues",
    image:
      "/images/construction.webp",
  },
  {
    slug: "transport",
    name: "Transport & Camionnage",
    examples: "Tracteurs routiers Freightliner/Kenworth, remorques, dompeurs, pickups HD",
    image:
      "/images/transport.webp",
  },
  {
    slug: "deneigement",
    name: "Déneigement & Municipal",
    examples: "Déneigeuses John Deere, souffleuses, grattes, épandeuses",
    image:
      "/images/deneigement.webp",
  },
  {
    slug: "agriculture",
    name: "Agriculture & Agroalimentaire",
    examples: "Tracteurs de ferme, moissonneuses, remorques de récolte",
    image:
      "/images/agriculture.webp",
  },
  {
    slug: "medical",
    name: "Médical & Esthétique",
    examples: "Appareils d'épilation laser, équipements dentaires, lasers médico-esthétiques",
    image:
      "/images/medical.webp",
  },
  {
    slug: "industriel",
    name: "Outillage Industriel & Machinage",
    examples: "Commandes numériques CNC, presses, chariots élévateurs, compresseurs",
    image:
      "/images/industriel.webp",
  },
];

export const CHAPTERS = [
  {
    number: "01",
    title: "La vitesse",
    description:
      "Les banques mettent des semaines. Nous analysons et approuvons votre dossier en 24 à 48 heures pour que vous ne ratiez jamais une opportunité d'affaires.",
  },
  {
    number: "02",
    title: "L'expertise terrain, le crédit flexible",
    description:
      "Nous connaissons le marché d'ici. Crédit difficile ou entreprise récente? Nous bâtissons la structure de financement qui fonctionne pour vous.",
  },
  {
    number: "03",
    title: "Un service clé en main, de A à Z",
    description:
      "Du premier appel jusqu'à la livraison chez votre marchand, votre courtier dédié s'occupe de toute la négociation financière. Vous, vous travaillez.",
  },
  {
    number: "04",
    title: "Une transparence totale, sans frais cachés",
    description:
      "Des mensualités fixes, des clauses claires et aucune mauvaise surprise en fin de contrat. Ce qu'on vous dit au départ, c'est ce que vous signez.",
  },
];

export const TESTIMONIALS = [
  {
    slug: "julie",
    client: "Julie M.",
    business: "Clinique Esthétique Pure",
    equipment: "Appareil d'épilation laser",
    quote:
      "Grâce à Solubail, j'ai pu acquérir mon appareil d'épilation laser sans stress. Service rapide et super professionnel!",
  },
  {
    slug: "nicolas",
    client: "Nicolas R.",
    business: "Inspection & Survey Nord",
    equipment: "Drone thermique spécialisé",
    quote:
      "L'équipe de Solubail a compris mes besoins techniques et m'a proposé un financement sur mesure pour mon drone thermique.",
  },
  {
    slug: "mathieu",
    client: "Mathieu P.",
    business: "Transport M.P. Express",
    equipment: "Camion Freightliner",
    quote:
      "Mon financement pour le Freightliner s'est fait sans tracas. Un service clé en main, parfait pour un entrepreneur comme moi.",
  },
  {
    slug: "michele",
    client: "Michèle L.",
    business: "Excavation M.L. & Fills",
    equipment: "Excavatrice",
    quote:
      "En tant que femme en construction, j'ai été écoutée et bien accompagnée. Mon excavatrice est maintenant en service grâce à eux.",
  },
  {
    slug: "antoine",
    client: "Antoine B.",
    business: "Déneigement A.B. Enr.",
    equipment: "Loader de déneigement",
    quote:
      "Hiver après hiver, mon loader me rapporte gros. Merci à Solubail d'avoir cru en mon projet.",
  },
  {
    slug: "stephane",
    client: "Stéphane C.",
    business: "Entreprise Électrique S.C.",
    equipment: "Flotte de pickups",
    quote:
      "Deux pickups financés sans m'endetter inutilement. Une belle relation de confiance qui commence.",
  },
  {
    slug: "hugo",
    client: "Hugo T.",
    business: "Les Constructions H.T.",
    equipment: "Camion RAM",
    quote:
      "J'ai obtenu le financement de mon RAM en quelques jours. Honnêtement, j'étais surpris par la rapidité et l'efficacité.",
  },
  {
    slug: "anthony",
    client: "Anthony G.",
    business: "Entretien Paysager A.G.",
    equipment: "Déneigeuse JD4066",
    quote:
      "Solubail a facilité l'achat de ma déneigeuse JD4066. Ils savent ce que veut dire rapidité.",
  },
];

export const FAQ = [
  {
    q: "Quels types d'équipements puis-je financer avec Solubail?",
    a: "Nous finançons presque tous les équipements neufs ou d'occasion à usage commercial : machinerie lourde de construction, camions et remorques, matériel de déneigement, équipements agricoles, appareils médicaux et esthétiques, outillage industriel et véhicules de flotte.",
  },
  {
    q: "Combien de temps prend l'approbation de mon dossier?",
    a: "La majorité de nos dossiers reçoivent une réponse ferme dans un délai de 24 à 48 heures ouvrables suivant la réception des documents requis.",
  },
  {
    q: "Est-il possible d'obtenir un crédit-bail avec un crédit difficile?",
    a: "Oui. En tant que courtier spécialisé, nous collaborons avec un vaste réseau de prêteurs aux critères variés. Nous évaluons l'ensemble de votre entreprise et la valeur de l'équipement, pas seulement votre cote de crédit.",
  },
  {
    q: "Quels sont les avantages fiscaux du crédit-bail au Québec?",
    a: "Au Québec et au Canada, les loyers de crédit-bail sont généralement déductibles à 100 % à titre de dépenses d'exploitation, ce qui réduit directement votre revenu imposable comparativement à un achat traditionnel.",
  },
];

export const EQUIPMENT_OPTIONS = [
  "Machinerie de construction / Excavation",
  "Camion lourd / Remorque / Transport",
  "Déneigement / Matériel municipal",
  "Équipement agricole",
  "Appareil médical / Esthétique",
  "Outillage industriel / Autre",
];

export const AMOUNT_OPTIONS = [
  "10 000$ - 25 000$",
  "25 000$ - 50 000$",
  "50 000$ - 100 000$",
  "100 000$ - 250 000$",
  "250 000$ et plus",
];
